<template>
  <h1></h1>
</template>

<script>
export default {
  name: "Home"
};
</script>

<style></style>
